import { render } from "./CreateNewPassword.vue?vue&type=template&id=47600465&scoped=true"
import script from "./CreateNewPassword.vue?vue&type=script&lang=js"
export * from "./CreateNewPassword.vue?vue&type=script&lang=js"

import "./CreateNewPassword.vue?vue&type=style&index=0&id=47600465&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47600465"]])

export default __exports__